import script from "./cguInstallers.vue?vue&type=script&setup=true&lang=js"
export * from "./cguInstallers.vue?vue&type=script&setup=true&lang=js"

import "./cguInstallers.vue?vue&type=style&index=0&id=2571b17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2571b17a"]])

export default __exports__